<template>
  <div class="rule">
    <div class="rule-warp">
      <div class="csgo-back-title">
        <h5 @click="goLucky">幸运饰品</h5>
        >
        <h6>活动规则</h6>
      </div>

      <div class="rule-text">
        <div class="text-title">{{ boxInfo.name }}</div>
        <div v-html="boxInfo.content" class="html-box"></div>
      </div>
    </div>
    <div class="commonBg"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      boxInfo: {
        name: '',
        content: ''
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    goLucky() {
      this.$router.push({
        path: `/lucky`,
      });
    },
    getData() {
      this.$doGet("/api/setting.Accord/info", {
        accord_id: 'BoxLucky'
      }).then((res) => {
        this.boxInfo = res.data
      }).catch(() => { })
    }
  }
};
</script>

<style lang="less" scoped>
.rule {
  .rule-warp {
    padding: 16px;
  }
  .rule-input {
    display: table;
    margin-top: 30px;
    padding: 16px;
    background-color: #2b2c37;
    border-radius: 5px;
    .input-title {
      font-size: 16px;
      color: #c3c3e2;
    }
    .input {
      padding: 16px 0;
      input {
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        border-radius: 5px;
        width: 400px;
        color: #c3c3e2;
        font-size: 12px;
        background-color: #24252f;
        outline: none;
        box-sizing: border-box;
        border: none;
      }
      span {
        display: inline-table;
        height: 40px;
        margin-left: 20px;
        line-height: 40px;
        padding: 0 20px;
        background-color: #e9b10e;
        border-radius: 5px;
        font-weight: 600;
        color: #1a1c24;
        font-size: 15px;
      }
      span:hover {
        cursor: pointer;
        background-color: #f5c432;
      }
    }
  }
}
</style>